import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tw-w-2/3" }

import { Form, Page } from '../../types/recap'
import { computed, nextTick, reactive, ref, watch } from 'vue'
import RecapForm from './RecapForm.vue'
import { useSharedRecap } from '../../composables/recaps/useRecap'
import { Nullish } from '../../types/utility'


export default /*#__PURE__*/_defineComponent({
  __name: 'RecapPage',
  props: {
    pageId: {}
  },
  setup(__props: any, { expose: __expose }) {

const { getFormRef, getPageById, triggerAllConditions, hiddenPages, taskOrStoreId, recapType } =
  useSharedRecap()

const props = __props

const currentPage = ref<Page | Nullish>(getPageById(props.pageId))
watch(
  () => props.pageId,
  () => {
    if (props.pageId !== currentPage.value?.id) {
      currentPage.value = getPageById(props.pageId)
    }
  }
)

const isPageHidden = computed(() => !hiddenPages.value.includes(props.pageId))

const forms = computed(() => currentPage.value?.items || currentPage.value?.forms || [])

const allSurveyEntries = reactive<{ [key: string]: string[] }>({})
function surveyEntries(formId: string) {
  let entriesForForm = allSurveyEntries[formId]
  if (!entriesForForm) {
    entriesForForm = [formId]
    allSurveyEntries[formId] = entriesForForm
  }
  return entriesForForm
}
function addSurveyEntry(formId: string) {
  allSurveyEntries[formId].push(new Date().toString())

  // Trigger all logic conditions when adding a survey form
  // so all the fields within are properly shown
  // Must happen after the form has completely rendered, hence the `nextTick()`
  nextTick(() => {
    triggerAllConditions.value = true
  }).catch(() => null)
}
function removeSurveyEntry(formId: string, index: number) {
  if (allSurveyEntries[formId].length > 1) {
    allSurveyEntries[formId].splice(index, 1)
  }
}

function getPageId() {
  return props.pageId
}

__expose({
  getPageId,
})

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forms.value, (form, simpleFormIndex) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: `${_unref(recapType)}-${_unref(taskOrStoreId)}-${(form as Form).id}`
      }, [
        ((form as Form).form_type === 'simple')
          ? (_openBlock(), _createBlock(RecapForm, {
              key: 0,
              ref_for: true,
              ref: (_unref(getFormRef) as any),
              form: form,
              "repeating-index": simpleFormIndex
            }, null, 8, ["form", "repeating-index"]))
          : ((form as Form).form_type === 'product')
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList((form as Form).products, (product, repeatingIndex) => {
                return (_openBlock(), _createBlock(RecapForm, {
                  key: `${_unref(recapType)}-${_unref(taskOrStoreId)}-${(form as Form).id}-${repeatingIndex}-${product.id}`,
                  ref_for: true,
                  ref: (_unref(getFormRef) as any),
                  form: form,
                  product: product,
                  "repeating-index": repeatingIndex
                }, null, 8, ["form", "product", "repeating-index"]))
              }), 128))
            : ((form as Form).form_type === 'survey')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(surveyEntries((form as Form).id), (surveyEntry, repeatingIndex) => {
                  return (_openBlock(), _createBlock(RecapForm, {
                    key: `${_unref(recapType)}-${_unref(taskOrStoreId)}-${(form as Form).id}-${repeatingIndex}`,
                    ref_for: true,
                    ref: (_unref(getFormRef) as any),
                    form: form,
                    "repeating-index": repeatingIndex,
                    "last-survey": 
              repeatingIndex !== 0 &&
              repeatingIndex + 1 === surveyEntries((form as Form).id).length
            ,
                    onAddSurvey: ($event: any) => (addSurveyEntry((form as Form).id)),
                    onRemoveSurvey: ($event: any) => (removeSurveyEntry((form as Form).id, repeatingIndex))
                  }, null, 8, ["form", "repeating-index", "last-survey", "onAddSurvey", "onRemoveSurvey"]))
                }), 128))
              : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ], 512)), [
    [_vShow, !isPageHidden.value]
  ])
}
}

})